import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconIndividual = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.4844 7.71657C10.4653 8.74032 9.05531 9.37501 7.5 9.37501C5.94469 9.37501 4.53469 8.74032 3.51562 7.71657C1.40625 9.04313 0 11.3859 0 14.0625V15H15V14.0625C15 11.3859 13.5938 9.04313 11.4844 7.71657Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.5 7.5C9.57107 7.5 11.25 5.82107 11.25 3.75C11.25 1.67893 9.57107 0 7.5 0C5.42893 0 3.75 1.67893 3.75 3.75C3.75 5.82107 5.42893 7.5 7.5 7.5Z",
		fill: "currentColor"
	})]
});
export default SvgIconIndividual;
